import {HiCheck, HiExclamationCircle, HiInformationCircle, HiX, HiXCircle} from 'react-icons/hi';

import * as Dialog from '@radix-ui/react-dialog';

import {useConfirmDialogStore} from '@/store/confirmDialogStore';

const iconMap = {
  success: {
    icon: <HiCheck className="w-6 h-6" />,
    bg: 'bg-green-100',
    color: 'text-green-600'
  },
  info: {
    icon: <HiInformationCircle className="w-6 h-6" />,
    bg: 'bg-blue-100',
    color: 'text-blue-600'
  },
  warning: {
    icon: <HiExclamationCircle className="w-6 h-6" />,
    bg: 'bg-yellow-100',
    color: 'text-yellow-600'
  },
  error: {
    icon: <HiXCircle className="w-6 h-6" />,
    bg: 'bg-red-100',
    color: 'text-red-600'
  }
};

const GlobalConfirmDialog = () => {
  const {isOpen, message, type, onConfirm, onCancel, closeDialog} = useConfirmDialogStore();
  const iconData = iconMap[type];

  return (
    <Dialog.Root open={isOpen} onOpenChange={(open) => !open && closeDialog()}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 bg-black/30 backdrop-blur-sm z-60" />
        <Dialog.Content
          className="fixed top-1/2 left-1/2 z-70 -translate-x-1/2 -translate-y-1/2
          w-[90vw] max-w-sm rounded-xl bg-white px-6 py-5 shadow-lg focus:outline-none"
        >
          <Dialog.Close asChild>
            <button
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
              aria-label="Close"
              onClick={closeDialog}
            >
              <HiX className="w-5 h-5" />
            </button>
          </Dialog.Close>

          <div className={`mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full ${iconData.bg}`}>
            <div className={`${iconData.color}`}>{iconData.icon}</div>
          </div>

          <Dialog.Title className="text-center text-lg leading-relaxed text-gray-800 font-medium whitespace-pre-line">
            {message}
          </Dialog.Title>

          <div className="mt-6 flex justify-center gap-3">
            <button
              className="inline-flex items-center gap-1 px-4 py-1.5 rounded-md bg-blue-600 text-white font-medium hover:bg-blue-700 transition"
              onClick={() => {
                onConfirm?.();
                closeDialog();
              }}
            >
              <HiCheck className="w-4 h-4" />
              확인
            </button>
            <button
              className="inline-flex items-center gap-1 px-4 py-1.5 rounded-md border border-blue-600 text-blue-600 font-medium hover:bg-blue-50 transition"
              onClick={() => {
                onCancel?.();
                closeDialog();
              }}
            >
              <HiX className="w-4 h-4" />
              취소
            </button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default GlobalConfirmDialog;
